"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardTaskSortOption = exports.DashboardTaskExpandOption = exports.DashboardTaskDynamicGroupingOption = exports.DashboardTaskTimeContext = exports.DashboardTaskStaticGroupingOption = exports.DashboardTaskWorkStatusGrouping = void 0;
const database_types_1 = require("@acumen/database-types");
Object.defineProperty(exports, "DashboardTaskWorkStatusGrouping", { enumerable: true, get: function () { return database_types_1.AcumenTaskStatusGroup; } });
var DashboardTaskStaticGroupingOption;
(function (DashboardTaskStaticGroupingOption) {
    DashboardTaskStaticGroupingOption["WorkStatus"] = "WorkStatus";
    DashboardTaskStaticGroupingOption["WorkStatusBacklog"] = "WorkStatusBacklog";
    DashboardTaskStaticGroupingOption["WorkStatusInProgress"] = "WorkStatusInProgress";
    DashboardTaskStaticGroupingOption["WorkStatusDone"] = "WorkStatusDone";
})(DashboardTaskStaticGroupingOption = exports.DashboardTaskStaticGroupingOption || (exports.DashboardTaskStaticGroupingOption = {}));
var DashboardTaskTimeContext;
(function (DashboardTaskTimeContext) {
    DashboardTaskTimeContext["CreatedDate"] = "CreatedDate";
    DashboardTaskTimeContext["UpdatedDate"] = "UpdatedDate";
})(DashboardTaskTimeContext = exports.DashboardTaskTimeContext || (exports.DashboardTaskTimeContext = {}));
var DashboardTaskDynamicGroupingOption;
(function (DashboardTaskDynamicGroupingOption) {
    DashboardTaskDynamicGroupingOption["Highlights"] = "Highlights";
})(DashboardTaskDynamicGroupingOption = exports.DashboardTaskDynamicGroupingOption || (exports.DashboardTaskDynamicGroupingOption = {}));
var DashboardTaskExpandOption;
(function (DashboardTaskExpandOption) {
    DashboardTaskExpandOption["Highlights"] = "Highlights";
    DashboardTaskExpandOption["Progress"] = "Progress";
    DashboardTaskExpandOption["RelatedPRs"] = "RelatedPRs";
})(DashboardTaskExpandOption = exports.DashboardTaskExpandOption || (exports.DashboardTaskExpandOption = {}));
var DashboardTaskSortOption;
(function (DashboardTaskSortOption) {
    DashboardTaskSortOption["CreatedDate"] = "CreatedDate";
    DashboardTaskSortOption["UpdatedDate"] = "UpdatedDate";
    DashboardTaskSortOption["Rank"] = "Rank";
})(DashboardTaskSortOption = exports.DashboardTaskSortOption || (exports.DashboardTaskSortOption = {}));
//# sourceMappingURL=dashboard-task.js.map